<template>
  <div>
    <v-btn
      dark
      color="primary"
      class="ma-0"
      @click="abrirDialog()"
    >
      <v-icon left>mdi-import</v-icon>
      Importar
    </v-btn>

    <SysDialog
      v-model="dialog"
      content-class="bra-20"
      titulo="Importação de lista"
      :ocultarAcoes="trocar_tela"
      @click:primary="importarLista()"
      @click:hidden-dialog="fecharDialog()"
    >
      <template v-if="!trocar_tela">
        <AlertError :errors="errors" />

        <InformativoFormatoArquivo class="mb-2" :informativos="dados_importacao.informativo"/>

        <SysFileInput
          v-model="arquivo_importacao"
          titulo_label="Arquivo de Importação"
          outlined
          :error-messages="ERROR_ARQUIVO_IMPORTACAO"
          @keydown.enter="importarLista"
        />
      </template>

      <template v-else>
        <div class="text-center">
          <v-icon class="my-5" color="green" :size="80">mdi-file-upload</v-icon>
          <p class="font-14">Arquivo importado com sucesso!</p>
        </div>
      </template>
    </SysDialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import InformativoFormatoArquivo from './InformativoFormatoArquivo.vue';
import AlertError from '@/components/utils/Alerts/AlertError.vue';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysFileInput from '@/components/utils/SysFileInput.vue';
import Api from '@/api/api.js';

export default {
  components: {
    SysDialog,
    SysFileInput,
    InformativoFormatoArquivo,
    AlertError
  },
  props: {
    dados_importacao: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      arquivo_importacao: null,
      errors: [],
      trocar_tela: false
    }
  },
  computed: {
    ERROR_ARQUIVO_IMPORTACAO() {
      const errors = [];
      if (!this.$v.arquivo_importacao.$dirty) return errors;
      !this.$v.arquivo_importacao.required && errors.push("Campo obrigatório.");
      return errors;
    },
  },
  methods: {
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog = false;
      this.arquivo_importacao = null;
      this.errors = [];
      this.trocar_tela = false;
    },
    async importarLista() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const config = {
        headers: {
          ...this.Helpers.iniciarRequisicao(),
          'Content-Type': 'multipart/form-data'
        }
      };

      const formData = new FormData();
      formData.append('arquivo_importacao', this.arquivo_importacao);
      formData.append('user_id', localStorage.getItem('id'));

      await Api
        .post(this.dados_importacao.url, formData, config)
        .then(response => {
          const { token, messageError } = response.data;
          localStorage.setItem('token', token);

          if (messageError) {
            this.errors = [messageError];
          } else {
            this.errors = [];
            this.trocar_tela = true;
          }
        })
        .catch(() => this.Helpers.logout())

        .finally(() => setTimeout(() => { this.errors = []}, 10000));
    },
  },
  validations: {
    arquivo_importacao: { required }
  }
}
</script>
